/**
 * @description Gestion du sommaire
 */

/* global bsBreakpoints $toggle */

(() => {
	// VARS
	const root = document.querySelector('[data-selector-page-summary]');
	const jobPage = document.querySelector('.page-job') || null;
	let allH2;
	// Condition pour offre d'emploi, ajout du h2 du bloc summary-job dans le sommaire
	if (jobPage) {
		allH2 = jobPage.querySelectorAll('h2');
	}
	// Si  !page offre emploi alors on selectionne les H2 des .a-edito
	else {
		allH2 = document.querySelector('.a-edito').querySelectorAll('h2');
	}
	let hasH2 = true;
	if (allH2.length === 0) {
		hasH2 = false;
	}
	const hasCalendar = document.querySelector('#event-calendar');

	const $ = {
		toggle: 'data-page-summary-title',
		content: 'data-page-summary-content',
		figcaption: 'data-js-figcaption',
	};

	// Fonctions
	const addID = (el) => {
		let index = 1;

		el.forEach((item) => {
			item.id = `h2-${index}`;

			if (item.offsetTop === 0) {
				item.setAttribute(
					'data-title-position',
					item.parentElement.offsetTop
				);
			} else {
				item.setAttribute('data-title-position', item.offsetTop);
			}

			index++;
		});
	};

	const toggle = () => {
		root.querySelector(`[${$.toggle}]`).addEventListener('click', () => {
			const el = root.querySelector(`[${$.content}]`);
			const chevron = root.querySelector(`[${$.toggle}]`);
			if (chevron.getAttribute('data-toggle-status') === 'active') {
				chevron.setAttribute('data-toggle-status', 'inactive');
				chevron.setAttribute('aria-expanded', false);
				el.classList.remove('active');
				if (
					bsBreakpoints.detectBreakpoint() === 'small' ||
					bsBreakpoints.detectBreakpoint() === 'xSmall'
				) {
					root.classList.remove('open');
					document.querySelector('body').classList.remove('fixed');
				}
			} else {
				chevron.setAttribute('data-toggle-status', 'active');
				el.classList.add('active');
				chevron.setAttribute('aria-expanded', true);
				if (
					bsBreakpoints.detectBreakpoint() === 'small' ||
					bsBreakpoints.detectBreakpoint() === 'xSmall'
				) {
					root.classList.add('open');
					document.querySelector('body').classList.add('fixed');
				}
			}
			$toggle(el, 'block');
		});
	};

	const constructSummary = (el) => {
		let content = `<div class="page-summary-card card">
                        <button type="button" class="page-summary__title card-header" data-toggle-status="active" data-page-summary-title aria-expanded="true">Sommaire<i data-icon="chevron" aria-hidden="true"></i></button>
                        <ul class="page-summary__content card-body active" data-page-summary-content>`;

		el.forEach((item) => {
			content += `<li class="page-summary__content__link" data-position="${item.getAttribute(
				'data-title-position'
			)}">

				<div class="page-summary__content__section">
					<span class="page-summary__content__link__puce"></span>
					<a class="stretched-link page-summary__content__link--link" href="#${
						item.id
					}" data-dot="3">${item.innerText}</a>
				</div>
				<div class="page-summary__content__separate"></div>
			</li>`;
		});

		content += `</ul></div>`;

		root.innerHTML = content;

		// On ouvre pas le menu en RWD
		if (
			bsBreakpoints.detectBreakpoint() === 'medium' ||
			bsBreakpoints.detectBreakpoint() === 'small' ||
			bsBreakpoints.detectBreakpoint() === 'xSmall'
		) {
			document
				.querySelector('[data-page-summary-title]')
				.setAttribute('data-toggle-status', 'inactive');
			document
				.querySelector('[data-page-summary-title]')
				.setAttribute('aria-expanded', 'false');
			document
				.querySelector('[data-page-summary-content]')
				.classList.remove('active');
		}
	};

	/* Gestion classe active sur elements du sommaire */

	const moveInPage = () => {
		const liTitle = root.querySelectorAll('.page-summary__content__link');
		let lastLiActive;

		document.addEventListener('scroll', () => {
			liTitle.forEach((item) => {
				item.classList.add('active');

				if (
					item.getAttribute('data-position') >= window.pageYOffset &&
					lastLiActive
				) {
					item.classList.remove('active');
					lastLiActive
						.querySelector('.page-summary__content__link--link')
						.removeAttribute('aria-current');
				}

				if (item.classList.contains('active')) {
					const liActives = root.querySelectorAll(
						'.page-summary__content__link.active'
					);
					lastLiActive = liActives[liActives.length - 1];
				}

				lastLiActive
					.querySelector('.page-summary__content__link--link')
					.removeAttribute('aria-current');
			});

			lastLiActive
				.querySelector('.page-summary__content__link--link')
				.setAttribute('aria-current', true);
		});
	};

	/* --------------------------------------------------- */

	const editMargin = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			let summaryHeight = root.getBoundingClientRect();
			// eslint-disable-next-line no-unused-vars
			summaryHeight = summaryHeight.height;

			root.classList.add('page-summary--sticky');
			root.addEventListener('click', () => {
				let summaryHeight = root.getBoundingClientRect();
				// eslint-disable-next-line no-unused-vars
				summaryHeight = summaryHeight.height;
			});
		} else {
			root.classList.remove('page-summary--sticky');
			document.querySelector('.a-edito').setAttribute('style', '');
		}

		if (document.body.contains(hasCalendar)) {
			root.classList.remove('col-lg-3');
			root.classList.add('page-summary--hasCalendar');
			root.parentElement.classList.remove('row');
			document.querySelector('.a-edito').setAttribute('style', '');
		}
	};

	// add margin top when click on a anchor, prevent title to be hidden by the header
	const anchorMargin = () => {
		// Captures click events of all <a> elements with href starting with #
		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener('click', (e) => {
				// Click events are captured before hashchanges. Timeout
				// causes offsetAnchor to be called after the page jump.
				e.preventDefault();
				const h2 = document.querySelector(anchor.getAttribute('href'));
				const header = document.querySelector('[data-js-header]');
				const topPos =
					h2.getBoundingClientRect().top + window.pageYOffset - 150;
				if (elementInViewport(header)) {
					// eslint-disable-next-line no-unused-expressions
					topPos - header.offsetHeight;
				}

				window.scrollTo({
					top: topPos, // scroll so that the element is at the top of the view
					behavior: 'smooth', // smooth scroll
				});
			});
		});
	};

	// funciton to return if header is visible in page to set anchor top position
	const elementInViewport = (el) => {
		let top = el.offsetTop;
		let left = el.offsetLeft;
		const width = el.offsetWidth;
		const height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
			top >= window.pageYOffset &&
			left >= window.pageXOffset &&
			top + height <= window.pageYOffset + window.innerHeight &&
			left + width <= window.pageXOffset + window.innerWidth
		);
	};

	// GO 🚀
	const init = () => {
		if (document.body.contains(root)) {
			document.body.classList.add('hasSummary');
			root.parentElement.classList.add('row', 'content');

			const contenu = document.querySelector('.row.content').children;

			for (let i = 0; i < contenu.length; i++) {
				const element = contenu[i];

				if (element.classList.contains('a-edito')) {
					element.classList.add('col-lg-9');
				}
			}

			if (document.querySelector('[data-js-figcaption]') !== null) {
				document
					.querySelector('[data-js-figcaption]')
					.classList.add('hasSummary');
			}

			addID(allH2);
			constructSummary(allH2);
		}
		// moveInPage();
		if (document.body.contains(root)) {
			if (allH2.length > 1) {
				window.onresize = function () {
					editMargin();
					toggle();
				};
			}
			toggle();

			moveInPage();

			document.addEventListener('DOMContentLoaded', () => {
				editMargin();
			});
		}
	};

	if (hasH2) {
		init();
		anchorMargin();
	}
})();
